import {snapshotOrders$, incrementalOrders$} from '@/orders-spot/orders-spot';
import {createFillOrdersCache$} from '@/spot-utils/orders-fill-cache';
import type {ws} from '@/types';
type FillSpotOrderRaw = ws.FillSpotOrderRaw;

export const spotFillOrdersCache$ = createFillOrdersCache$<FillSpotOrderRaw>(snapshotOrders$, incrementalOrders$);
